import React from 'react';
import { useShouldRenderBlueprint } from '../../useShouldRenderBlueprint';
import VariantComponent from '../../variant-component';
import BlueprintThemeStyle from './blueprint-theme-style';
import BuieThemeStyle from './buie-theme-style';
import type { ThemeStyleProps } from './types';

const ThemeStyle = (props: ThemeStyleProps) => {
  // Should be addressed in FORMS-21224
  const shouldRenderBlueprint = useShouldRenderBlueprint();

  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintThemeStyle}
      OldComponent={BuieThemeStyle}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default ThemeStyle;
